import PdfComponent from 'src/components/PdfComponent';
import { HTMLTable } from '@blueprintjs/core';
import pdfData from 'assets/preprints/construction-of-knowledge-in-science.pdf';
import * as React from 'react';
export default {
  PdfComponent,
  HTMLTable,
  pdfData,
  React
};